<ion-content *ngIf="activeItems?.length; else empty">
	<ion-list>
		<ion-item-group *ngFor="let item of activeItems; index as index">
			<app-inventory-item
				[item]="item"
				[index]="index"
				[isExpanded]="isVisible(index)"
				(toggledSection)="onClickToggleSection($event)"
			></app-inventory-item>
		</ion-item-group>
	</ion-list>
</ion-content>

<ng-template #empty>
	<app-empty-list-item
		message="No active inventory on this structure"
	></app-empty-list-item>
</ng-template>
